// URL where third-party-check/index.html is deployed.
// Replace with the real deployment URL before going to production.
const THIRD_PARTY_CHECK_URL = "https://image.shopflo.com/third-party-check.html";

const RESULT_MESSAGE_TYPE = "FLO_THIRD_PARTY_COOKIE_RESULT";
const TIMEOUT_MS = 5000;

/**
 * Opens a hidden iframe on the third-party check domain and asks it to set a
 * cookie. Returns true if the browser allowed it (third-party cookies are
 * enabled), false if they are blocked or the check times out.
 *
 * Call this from a first-party context (the merchant storefront or a page
 * running on the merchant's domain) to determine whether Shopflo's third-party
 * cookies will work for the current user.
 */
export function checkThirdPartyCookieEnabledFromFirstParty(): Promise<boolean> {
  return new Promise((resolve) => {
    const iframe = document.createElement("iframe");
    iframe.src = THIRD_PARTY_CHECK_URL;
    iframe.style.cssText =
      "display:none;width:0;height:0;border:none;position:absolute;top:-9999px;left:-9999px;";
    let settled = false;

    const timer = setTimeout(() => {
      if (!settled) {
        settled = true;
        cleanup();
        resolve(false); // treat timeout as blocked
      }
    }, TIMEOUT_MS);

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === RESULT_MESSAGE_TYPE && !settled) {
        settled = true;
        cleanup();
        resolve(Boolean(event.data?.payload?.enabled));
      }
    };

    const cleanup = () => {
      clearTimeout(timer);
      window.removeEventListener("message", handleMessage);
      iframe.remove();
    };

    window.addEventListener("message", handleMessage);
    document.body.appendChild(iframe);
  });
}
